import React, { useState } from 'react'
import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'
import { packageCategories } from 'variables/general'
import { BsFillCircleFill } from 'react-icons/bs'
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa'
import { convertToYouTubeEmbedURL, convertVimeoUrl } from 'variables/functions'

// For Public Package and Marketplace Package
const PublicPackageCarousel = (props) => {
  const [itemIndex, setitemIndex] = useState(0)
  const [showIndicators, setShowIndicators] = useState(window.innerWidth > 700 ? false : true)
  const pack = props.pack
  const ImageAlt = `${pack.title} Photo by ${pack.photographer.companyName} in ${
    packageCategories[pack.category].name
  } Package, ${pack.location.name}`

  // IMAGE ARRAY TO ALLOW FOR DEFAULT FORWARD AND BACKWARDS CAROUSEL TRAVERSING
  let itemRow1 = props.items.map((item, index) => (
    <ImageContainer key={uuidv4()} show={index === itemIndex}>
      <Image
        src={window.innerWidth < 900 ? item.mobileThumbnail || item.image : item.image}
        width={props.width}
        alt={ImageAlt}
        index={index}
        onClick={() => props.openLightbox(index)}
      />
    </ImageContainer>
  ))

  if (!!props.video) {
    itemRow1.splice(
      0,
      0,
      <ImageContainer key={uuidv4()}>
        <Iframe
          title={pack.identifier}
          src={
            pack.videoUrl?.includes('vimeo')
              ? convertVimeoUrl(pack.videoUrl)
              : convertToYouTubeEmbedURL(pack.videoUrl)
          }
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </ImageContainer>,
    )
  }

  const [itemArray] = useState(itemRow1)

  // LOGIC FOR SHOWING WHAT TRAVERSE INDICATOR SHOULD HAVE ITS OPACITY SET TO ONE
  const TraverseIndicators = props.items.map((item, index) => {
    let shown = 'false'
    if (itemIndex + 1 > itemRow1.length && itemIndex - itemRow1.length === index) {
      shown = 'true'
    } else if (itemIndex < itemRow1.length && itemIndex === index) {
      shown = 'true'
    }

    return <TraverseIndicator key={item.identifier} shown={shown} />
  })

  // SET TIMEOUTS TO ONLY ENABLE THE CSS TRANSITION FEATURE FOR ONCLICK HANDLER USE
  const previousHandler = async () => {
    setTimeout(() => {
      if (itemIndex === 0) {
        setitemIndex(itemArray.length - 1)
      } else {
        setitemIndex(itemIndex - 1)
      }
    }, 5)
  }

  const nextHandler = async () => {
    setTimeout(() => {
      if (itemIndex === itemArray.length - 1) {
        setitemIndex(0)
      } else {
        setitemIndex(itemIndex + 1)
      }
    }, 5)
  }

  const nextIndex = () => {
    if (itemIndex === itemArray.length - 1) {
      return 0
    } else {
      return itemIndex + 1
    }
  }

  let leftOffset = `${itemIndex * -45}em`

  // TO HANDLE CASES OF ONLY ONE, TWO, OR THREE+ IMAGES IN CAROUSEL TO AVOID SAME KEY ERRORS
  let photoArray =
    itemArray.length === 1 ? itemArray[itemIndex] : [itemArray[itemIndex], itemArray[nextIndex()]]

  return (
    <Container
      page={props.page}
      onMouseEnter={() => {
        if (window.innerWidth > 700) {
          setShowIndicators(true)
        }
      }}
      onMouseLeave={() => {
        if (window.innerWidth > 700) {
          setShowIndicators(false)
        }
      }}
    >
      <ViewPort page={props.page}>
        <FlexRow>{itemArray.length > 1 && showIndicators && TraverseIndicators}</FlexRow>
        <ImageRowContainer leftOffset={leftOffset}>
          <PreRenderImageRow>{photoArray}</PreRenderImageRow>
        </ImageRowContainer>
        {itemArray.length > 1 && showIndicators && (
          <div>
            <LeftTraversal onClick={previousHandler}>
              <TraverseBackButton>
                <BackIndicator />
              </TraverseBackButton>
            </LeftTraversal>
            <RightTraversal onClick={nextHandler}>
              <TraverseForwardButton>
                <ForwardIndicator />
              </TraverseForwardButton>
            </RightTraversal>
          </div>
        )}
      </ViewPort>
    </Container>
  )
}

export default PublicPackageCarousel

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 72%;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;
  @media (max-width: 1350px) {
    width: 100%;
    height: 100%;
  }
`

const PreRenderImageRow = styled.div`
  position: absolute;
  display: flex;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  @media (max-width: 1350px) {
    width: max-content;
  }
`

const ViewPort = styled.div`
  position: relative;
  cursor: pointer;
  height: 100%;
  width: 100%;
  overflow: hidden;
  @media (max-width: 1350px) {
    width: 90vw;
    height: 60vw;
  }
`

const ImageRowContainer = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
`

const Image = styled.img`
  position: relative;
  height: 100%;
  object-fit: cover;
  object-position: 100% 50%;
`

const ImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  min-width: 100%;
  height: 100%;
  overflow: hidden;
  @media (max-width: 1350px) {
    height: auto;
    width: 90vw;
  }
`

const Iframe = styled.iframe`
  // position: absolute;
  display: flex;
  justify-content: center;
  margin: 70px 0 0 0;
  width: 66em;
  height: 85%;
  overflow: hidden;
  @media (max-width: 1600px) {
    margin: 80px 0 0 0;
    width: 60em;
    height: 80%;
  }
  @media (max-width: 1500px) {
    margin: 100px 0 0 0;
    left: 2%;
    height: 77%;
    width: 55em;
  }
  @media (max-width: 1400px) {
    width: 53em;
    height: 70%;
  }
  @media (max-width: 1350px) {
    margin: 60px 0 0 0;
    position: absolute;
    top: 5%;
    left: auto;
    height: 88%;
    width: 66em;
  }
  @media (max-width: 1200px) {
    margin: 40px 0 0 0;
  }
  @media (max-width: 1050px) {
    top: 0;
    width: 60em;
  }
  @media (max-width: 1000px) {
    width: 55em;
  }
  @media (max-width: 900px) {
    margin: 20px 0 0 0;
    width: 50em;
    height: 90%;
    top: 8%;
  }
  @media (max-width: 840px) {
    margin: 0;
    width: 45em;
    height: 80%;
    top: 10%;
  }
  @media (max-width: 740px) {
    width: 43em;
  }
  @media (max-width: 700px) {
    width: 98vw;
  }
`
const BackIndicator = styled(FaAngleLeft)`
  position: absolute;
  box-sizing: content-box;
  cursor: pointer;
  top: 50%;
  left: 148%;
  transform: translate(-50%, -50%);
  border-radius: 999em;
  z-index: 1;
  stroke-width: 0.2em;
  stroke: black;
  color: white;
  font-size: 3em;
  opacity: 0.5;
`

const ForwardIndicator = styled(FaAngleRight)`
  position: absolute;
  box-sizing: content-box;
  cursor: pointer;
  top: 50%;
  left: 48%;
  transform: translate(-50%, -50%);
  border-radius: 999em;
  z-index: 1;
  stroke-width: 0.2em;
  stroke: black;
  color: white;
  font-size: 3em;
  opacity: 0.5;
`
const TraverseBackButton = styled.button`
  background: 0 0;
  border: 0;
  justify-self: center;
  outline: 0;
  padding: 16px 8px;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  z-index: 2;
`

const TraverseForwardButton = styled.button`
  background: 0 0;
  border: 0;
  justify-self: center;
  outline: 0;
  padding: 16px 8px;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 15px;
  z-index: 2;
`

const LeftTraversal = styled.div`
  position: absolute;
  width: 20%;
  height: 100%;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;
`

const RightTraversal = styled.div`
  position: absolute;
  right: 0;
  width: 20%;
  height: 100%;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;
`

const FlexRow = styled.div`
  position: absolute;
  height: 50px;
  width: 100%;
  top: 87%;
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
  z-index: 1;
  @media (max-width: 700px) {
    width: 100%;
  }
  @media (max-width: 576px) {
    top: 90%;
  }
  @media (max-width: 400px) {
    top: 70%;
  }
`

const TraverseIndicator = styled(BsFillCircleFill)`
  color: white;
  font-size: 0.5em;
  margin: 0.4em;
  opacity: ${(props) => (props.shown === 'true' ? '1' : '0.4')};
`
